import { HtmlTagOptions, TextStyleOptions } from '@df/ui/atomic/atomic-options';
import { NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { NCmsComponentLinks } from './cms-component-links.interface';

export const CMS_COMPONENT_LINKS_CONFIG = <Omit<NICmsContentComponent.IMeta<NICmsContentComponent.IComponent>, 'type'>>{
    id: NCmsComponentLinks.ID,
    isAdvanced: true,
    name: 'Text or link lines',
    description: 'Component is optimised to work with meganav and footer nav but also usable on content pages',
    image: '/common/cms/links-component.png',
    tags: ['nav', 'menu', 'footer'],
    fields: [
        <NICmsContentField.IField>{
            key: 'textColor',
            type: NICmsContentField.EFieldType.colorPicker,
            title: 'Font color',
            default: 'white'
        },
        // text lines
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'items',
            title: 'Text Lines',
            itemName: 'Line',
            itemNameField: 'text',
            defaultSize: 3,
            fields: [
                {
                    key: 'text',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Copy',
                    default: 'This is new line',
                    required: true
                },
                <NICmsContentField.IField>{
                    key: 'activeTextColor',
                    type: NICmsContentField.EFieldType.colorPicker,
                    title: 'Active Text Color'
                },
                <NICmsContentField.IChoiceField>{
                    key: 'tag',
                    type: NICmsContentField.EFieldType.choice,
                    title: 'Title Force Tag',
                    description: 'For SEO reasons you may want to force particular HTML tag',
                    options: HtmlTagOptions
                },
                {
                    key: 'link',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Link',
                    description: 'Please use relative paths like: /some-page for internal references.',
                    default: undefined
                },
                <NICmsContentField.IChoiceField>{
                    key: 'textStyle',
                    type: NICmsContentField.EFieldType.choice,
                    title: 'Text Style',
                    options: TextStyleOptions,
                    default: undefined
                }
            ]
        }
    ]
};
